import React from 'react';
import Icon from '../../atoms/Icon';
import './NavItem.css';

interface NavItemProps {
  id: string;
  label: string;
  icon: 'dashboard' | 'cart' | 'cake' | 'calendar' | 'users' | 'chart' | 'gear' | 'storefront';
  isActive: boolean;
  isCollapsed: boolean;
  onClick: () => void;
}

const NavItem: React.FC<NavItemProps> = ({ 
  id, 
  label, 
  icon, 
  isActive, 
  isCollapsed, 
  onClick 
}) => {
  return (
    <button
      className={`nav-item ${isActive ? 'active' : ''}`}
      onClick={onClick}
    >
      <Icon type={icon} size="medium" />
      {!isCollapsed && <span>{label}</span>}
    </button>
  );
};

export default NavItem;
